import { useQuery } from 'urql'
import { fetchProviderName, LazyProvider } from 'app/components/shared/LazyProvider'
import { graphql } from 'app/generated/gql'

const LOCATION_KOLLA_CONSUMER_QUERY = graphql(`
  query LocationKollaConsumer($id: ID!) {
    location(id: $id) {
      id
      kollaConsumerId
    }
  }
`)

/**
 * A provider named by its Kolla resource name (`resources/provider_1`), as a
 * Procedure's `providerId` is. Provider records carry no location id, only the
 * Kolla consumer of the location they belong to, so the lookup is scoped by the
 * location's `kollaConsumerId`: the same resource name exists at every location.
 *
 * Every card on one location issues the same location query, which urql
 * collapses into one request, and each provider is fetched once per cache key.
 */
export function LazyResourceProvider(props: {
  locationId?: string | null
  resourceName?: string | null
  showSpinner?: boolean
}) {
  const [{ data }] = useQuery({
    query: LOCATION_KOLLA_CONSUMER_QUERY,
    variables: { id: props.locationId! },
    pause: !props.locationId || !props.resourceName,
  })
  const consumerId = data?.location?.kollaConsumerId
  const cacheKey = consumerId && props.resourceName ? `kolla-resource:${consumerId}:${props.resourceName}` : ``

  return (
    <LazyProvider
      cacheKey={cacheKey}
      fetchName={() =>
        fetchProviderName(
          cacheKey,
          `/api/providers/resource?kollaConsumerId=${encodeURIComponent(consumerId!)}&resourceName=${encodeURIComponent(props.resourceName!)}`,
        )
      }
      showSpinner={props.showSpinner}
    />
  )
}
